<template>
  <div>
    <v-card dark>
      <v-card-text>
        <v-form ref="form" v-model="formValid" readonly>
          <v-row
            v-for="(item, index) in getCurrencies"
            :key="index"
            class="d-flex align-center"
            dense
          >
            <v-col cols="1">
              <v-checkbox
                v-model="currentSystem.MOEDAPRINCIPAL"
                class="customClass"
                :color="
                  currentSystem.MOEDAPRINCIPAL == index ? 'yellow darken-1' : ''
                "
                :label="`Moeda ${index}`"
                :value="index"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" sm="2" md="2" lg="1">
              <c-input
                v-model="item.descricao"
                label="Descricao"
                placeholder="Código"
              />
            </v-col>
            <v-col cols="4" sm="2" md="2" lg="1">
              <c-input label="Simbolo" v-model="item.cifrao" />
            </v-col>
            <v-col cols="4" sm="2" md="2" lg="1">
              <c-input label="Operação" v-model="item.sinal" />
            </v-col>
            <v-col cols="4" sm="2" md="2" lg="2">
              <c-input label="Mascara" v-model="item.mascara" />
            </v-col>
            <v-col cols="1"> </v-col>
          </v-row>
          <v-divider class="mb-6"></v-divider>
          <v-row dense>
            <c-input
              label="Série Orçamento"
              v-model="currentSystem.SERIEORCAMENTO"
            />
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import cInput from '@/components/shared/base-input/BaseInput'

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'FormDadosFinanceiros',
  components: {
    cInput,
  },
  data: () => ({
    formValid: false,
    statusList: [
      { text: 'Sim', value: 'S' },
      { text: 'Não', value: 'N' },
    ],
    form: {},
  }),
  computed: {
    ...mapState('systemModule', ['currentSystem']),
    ...mapGetters({
      getCurrencies: 'systemModule/getSystemCurrencies',
    }),
  },
  methods: {
    ...mapActions('dialogModule', [
      'setShowLoadingDialog',
      'setLoadingDialogMessage',
    ]),
  },
}
</script>

<style scoped>
.customClass >>> label {
  font-size: 0.8em;
}
</style>
